import { Trans } from 'react-i18next';
import { Row, Col, Nav, Tab } from 'react-bootstrap';
import MainBlockLayout from '../../components/MainBlockLayout';
import { PTA_GALLERY_YEARS } from '../../data/PTAImagesData';
import { generateImageTabs } from "../../utils/common";
import React, { useState } from "react";

function MainBlock() {
  let [loading, setLoading] = useState(true);
  const yearEntries = Object.entries(PTA_GALLERY_YEARS);
  const defaultYear = yearEntries[0]?.[0];

  return (
    <>
      <div className="px-3 px-sm-4 px-md-5">
        <Trans i18nKey="pta main text"></Trans>
      </div>
      <h2 className="justify-content-center d-flex mt-5"><Trans i18nKey="our events" /></h2>
      <Tab.Container id="left-tabs-example" defaultActiveKey={defaultYear}>
        <Row className="justify-content-center d-flex">
          <Col sm={3}>
            <Nav variant="pills" className="flex-column">
              {yearEntries.map(([year]) => (
                <Nav.Item key={year}>
                  <Nav.Link eventKey={year} onClick={() => setLoading(true)}>{year}</Nav.Link>
                </Nav.Item>
              ))}
            </Nav>
          </Col>
        </Row>
        <Row className="justify-content-center d-flex">
          <Col sm={9}>
            <Tab.Content>
              {yearEntries.map(([year, gallery]) => (
                <Tab.Pane key={year} eventKey={year}>
                  <div className="pta-gallery">
                    {generateImageTabs(gallery.pta, loading, setLoading, "right")}
                  </div>
                </Tab.Pane>
              ))}
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </>
  )
}

export default MainBlockLayout(MainBlock);